// extracted by mini-css-extract-plugin
module.exports = {"AdminPageEdit":"AdminPageEdit_AdminPageEdit__g00RY","ContentBlockTitle":"AdminPageEdit_ContentBlockTitle__3qE95"};